<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="First name"
            v-model.trim="doc.first"
            type="text"
            placeholder="First name"
            id="firstName"
          ></v-text-field>
          <v-text-field
            label="Last name"
            v-model.trim="doc.last"
            type="text"
            placeholder="Last name"
            id="title"
          ></v-text-field>
          <v-text-field
            label="Last name"
            v-model.trim="doc.email"
            type="text"
            placeholder="Email"
            id="title"
          ></v-text-field>
          <v-text-field
            label="Company"
            v-model.trim="doc.company"
            type="text"
            placeholder="Company"
            id="company"
          ></v-text-field>
          <v-text-field
            label="Role"
            v-model.trim="doc.role"
            type="text"
            placeholder="Role"
            id="role"
          ></v-text-field>
          <v-text-field
            label="Initial"
            v-model.trim="initial"
            type="text"
            id="initial"
          ></v-text-field>
          <v-text-field
            label="Group"
            v-model.trim="group"
            type="text"
            id="group"
          ></v-text-field>
          <v-textarea
            name="Bio"
            label="Bio"
            v-model.trim="doc.bio"
            type="text"
            placeholder="Short bio"
            id="bio"
          ></v-textarea>
          <v-select
            :items="dropdownCategories"
            label="Web Role"
            v-model.trim="doc.webrole"
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
export default {
  name: "AdminUserUpload",
  data() {
    return {
      dropdownCategories: ["admin", "user"],
    };
  },
  props: {
    doc: Object,
  },
  computed: {
    initial() {
      return this.doc.first
        ? `${this.doc.first.substr(0, 1)}${this.doc.last.substr(0, 1)}`
        : null;
    },
  },
};
</script>
